import { SET_SEARCH_TEXT, CLEAR_SEARCH_TEXT } from '../actions';

export function setSearchText(payload) {
    return {
        type: SET_SEARCH_TEXT,
        payload
    }
}

export function clearSearchText(payload) {
    return {
        type: CLEAR_SEARCH_TEXT
    }
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/searchText.js